import React, { useState, useEffect, useContext } from "react";
import './detalhamento_bolsa.css';

import Detalhamento_bolsa from "./detalhamento_bolsa";
import Detalhamento_bolsa_novos from "./detalhamento_bolsa_novo";
import Detalhamento_bolsa_renovados from "./detalhamento_bolsa_renovado";
import Detalhamento_integral_unidade from "./detalhamento_integral_unidade";
import Detalhamento_integral_unidade_novos from "./detalhamento_integral_unidade_novos";
import Detalhamento_integral_unidade_renovados from "./detalhamento_integral_unidade_renovados";

import { Tabs, Tab } from "react-bootstrap";


const Detalhamento_bolsa_tabs = (props) => {

    return (
        <Tabs defaultActiveKey="Todos" id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="Todos" title="TODOS">
                <Detalhamento_bolsa {...props} />
            </Tab>
            <Tab eventKey="novos" title="NOVOS">
                <Detalhamento_bolsa_novos {...props} />
            </Tab>
            <Tab eventKey="renovados" title="RENOVADOS">
                <Detalhamento_bolsa_renovados {...props} />
            </Tab>
            <Tab eventKey="integral" title="INTEGRAL">
                <Detalhamento_integral_unidade {...props} />
            </Tab>
            <Tab eventKey="integralNovos" title="INTEGRAL - NOVOS">
                <Detalhamento_integral_unidade_novos {...props} />
            </Tab>
            <Tab eventKey="integralRenovados" title="INTEGRAL - RENOVADOS">
                <Detalhamento_integral_unidade_renovados {...props} />
            </Tab>
        </Tabs>
    );
};
export default Detalhamento_bolsa_tabs;


